(function(){
  var modal = document.getElementById('video-modal');
  var video = document.getElementById('how-video');

  if (modal && modal.parentNode !== document.body) {
    document.body.appendChild(modal);
  }

  if (!modal || !video) return;

  var videoURL = video.getAttribute('data-src') || '';

  function lockScroll(){
    var y = window.scrollY || 0;
    document.body.dataset.scrollY = y;
    document.body.style.position = 'fixed';
    document.body.style.top = (-y) + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  function unlockScroll(){
    var y = parseInt(document.body.dataset.scrollY || '0', 10) || 0;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, y);
  }

  function hardStopVideo(){
    try { video.pause(); } catch(e){}
    video.removeAttribute('src');
    video.load();
    try { video.currentTime = 0; } catch(e){}
  }

  function openModal(){
    if (modal.classList.contains('is-open')) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden','false');
    lockScroll();
    if (!video.src && videoURL){
      video.src = videoURL;
      video.load();
    }
    video.play().catch(function(){});
  }

  function closeModal(){
    hardStopVideo();
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden','true');
    unlockScroll();
  }

  // En Olivia, engancha directamente a los <a href="#video"> cuando existan (y si se re-renderizan).
  function bindTriggers(root){
    var scope = root || document;
    var links = scope.querySelectorAll('a[href="#video"]');
    links.forEach(function(a){
      if (a._vmBound) return;
      a._vmBound = true;
      a.addEventListener('click', function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        openModal();
      }, true);
    });
  }
  // inicial
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ bindTriggers(); });
  } else {
    bindTriggers();
  }
  // rebind si Olivia re-pinta secciones
  var mo = new MutationObserver(function(muts){
    muts.forEach(function(m){
      if (m.type === 'childList' && m.addedNodes && m.addedNodes.length){
        m.addedNodes.forEach(function(n){ if (n.nodeType === 1) bindTriggers(n); });
      }
    });
  });
  mo.observe(document.documentElement, {childList:true, subtree:true});

  // Cierre con X o fuera (si decides añadir backdrop dentro)
  modal.addEventListener('click', function(e){
    if (e.target.hasAttribute('data-close')) {
      e.preventDefault();
      closeModal();
    }
  });

  // Cerrar con ESC
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });
})();